import React from 'react';
import { useIntl } from 'react-intl';
import TimeoutToast from '../../PerformancePortal/CoachingForm/AutoSave/TimeoutToast';

interface DraftSavedToastProps {
  show: boolean;
  onClose: () => void;
}

const DraftSavedToast = (props: DraftSavedToastProps) => {
  const intl = useIntl();

  return (
    <TimeoutToast
      message={intl.formatMessage({
        id: 'cs_perfportal_coaching_saved_draft_success',
        defaultMessage: 'Draft successfully saved.',
      })}
      type='neutral'
      duration={3000}
      {...props}
    />
  );
};

export default DraftSavedToast;
